import React, { FC } from "react";

import { ShareEntryPointInputId, useBasketShare } from "@keepeek/commons";
import { KModalContentSection, ShareEntryPoint, withSuspense } from "@keepeek/refront-components";
import { useRecoilValue } from "recoil";

import { KIcon } from "../../../components/common/KIcon";
import { CONFIGURATION_SECTION_PATH } from "../../../components/layout/adminMenu";
import { ShareManager as ShareManagerConfig } from "../../../models/configuration/components/shareManager";
import { useConfiguration } from "../../../providers/config/hooks";
import { configSectionComponentBasketSelector } from "../../../providers/config/selectors";

import { CommonBasketShareProps } from "./index";

const PublicShareEntryPoint: FC<CommonBasketShareProps> = function ({
  basketId,
  basketTitle,
  sentryCallback,
  snackbarCallback,
}) {
  const { displayBackofficeSharedBasket } = useRecoilValue(
    configSectionComponentBasketSelector,
  ) ?? {
    displayBackofficeSharedBasket: undefined,
  };
  const { publicShare, publicShareLoading, copyEntryPoint } = useBasketShare(
    displayBackofficeSharedBasket ?? false,
    basketId,
    sentryCallback,
    snackbarCallback,
  );
  const shareManagerConfig = useConfiguration<ShareManagerConfig>(
    CONFIGURATION_SECTION_PATH.COMPONENTS_SHARE_MANAGER,
  );
  const basketPublicShareConfig = shareManagerConfig?.basketPublicShare;

  return (
    <KModalContentSection>
      <ShareEntryPoint
        entryPoint={publicShare?.entryPoint}
        entryPointInputId={ShareEntryPointInputId}
        loading={publicShareLoading}
        shareTitle={basketTitle}
        copyEntryPoint={copyEntryPoint}
        KIcon={KIcon}
        disableSocialNetworksLink={basketPublicShareConfig?.disableSocialNetworksLink}
      />
    </KModalContentSection>
  );
};

export default withSuspense(PublicShareEntryPoint);
